<template>
  <div class="p-4">
    <div class="row feedbackData-wrapper">
      <h5 class="mb-3">{{ $t("client-feedbacks") }} </h5>
      <section>
        <div class="client-general-information__data">
          <ul class="row m-0 p-0">
            <li class="col-12 mb-2">
              <h4>{{ $t("client-information") }}</h4>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-xl-3">
              <h5>{{ $t("name") }}</h5>
              <p>{{ feedbackData?.client.name || "-" }}</p>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-xl-3">
              <h5>{{ $t("name-in-arabic") }}</h5>
              <p>{{ feedbackData?.client.arabicName || "-" }}</p>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-xl-3">
              <h5>{{ $t("email-address") }}</h5>
              <p>{{ feedbackData?.client.email || "-" }}</p>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-xl-3">
              <h5>{{ $t("phone-number") }}</h5>
              <p>{{ feedbackData?.client.phoneNumber || "-" }}</p>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-xl-3">
              <h5>{{ $t("city") }}</h5>
              <p>{{ isLangRtl ? feedbackData?.client.city?.arabicName || "-" : feedbackData?.client.city?.name || "-"
              }}</p>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-xl-3">
              <h5>{{ $t("client-address") }}</h5>
              <p>{{ feedbackData?.client.address || "-" }}</p>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-xl-3">
              <h5>{{ $t("client-address-in-arabic") }}</h5>
              <p>{{ feedbackData?.client.arabicAddress || "-" }}</p>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-xl-3">
              <h5>{{ $t("payment-method") }}</h5>
              <p>{{ feedbackData?.client.paymentMethod ? $t(feedbackData?.client.paymentMethod?.toLowerCase()) : "-"
              }}</p>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-xl-3">
              <h5>{{ $t("commercial-registration-number") }}</h5>
              <p>{{ feedbackData?.client.registrationNumber || "-" }}</p>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-xl-3">
              <h5>{{ $t("client-vat-number") }}</h5>
              <p>{{ feedbackData?.client.vatNumber || "-" }}</p>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-xl-3">
              <h5>{{ $t("type") }}</h5>
              <p>
                {{
                  $t(feedbackData?.client.type)
                }}
              </p>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-xl-3">
              <h5>{{ $t("clients-grade") }}</h5>
              <p>
                {{
                  isLangRtl ? feedbackData?.client.clientGrade?.arabicName || "-" : feedbackData?.client.clientGrade?.name
                    || "-"
                }}
              </p>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-xl-3 row">
              <h5>{{ $t("invoicing-upon-delivery") }}</h5>
              <p>
                {{
                  feedbackData?.client.invoicingUponDelivery ? $t("yes") : $t("no")
                }}
              </p>
            </li>
          </ul>
        </div>
      </section>
      <section>
        <div class="client-general-information__data">
          <ul class="row m-0 p-0">
            <li class="col-12 mb-2">
              <h4>{{ $t("feedback-ratings") }}</h4>
            </li>
          </ul>
          <b-list-group-item class="mb-2" v-for="(rating, key) in feedbackData.feedbackRatings" :key="key">
            <p>{{ $t(key) }}</p>
            <b-progress :value="rating * 20" max="100" variant="info" height="20px">
              <b-progress-bar :value="rating * 20">{{ rating }}/5</b-progress-bar>
            </b-progress>
          </b-list-group-item>
        </div>
      </section>
      <section>
        <div class="trip-place-container mb-3">
          <ul class="row m-0 p-0">
            <li class="col-12 mb-2">
              <h4>{{ $t("cities-and-address") }}</h4>
            </li>
          </ul>
          <div class="d-flex justify-content-between mb-4">
            <div>
              <div>{{ $t("from-city") }}</div>
              <div class="bold-text">
                {{ feedbackData?.trip?.startLocation?.name }}
              </div>
            </div>
            <div>
              <div>{{ $t("to-city") }}</div>
              <div class="bold-text">
                {{ feedbackData?.trip?.endLocation?.name }}
              </div>
            </div>
          </div>
          <div style="position: relative">
            <div class="route"></div>

            <div class="point" :style="isLangRtl ? 'right: 25%;' : 'left: 25%;'" :class="{
              'pick-up': feedbackData?.trip?.startLocation?.name,
              start: !feedbackData?.trip?.startLocation?.name,
            }" v-if="feedbackData?.trip.startLocation?.name" v-b-tooltip.hover="{
              title: feedbackData?.trip.startLocation?.name,
              placement:
                isLangRtl && !feedbackData?.trip?.startLocation?.name
                  ? 'righttop'
                  : 'lefttop',
            }">
            </div>

            <div class="point" :style="isLangRtl ? 'left: 25%;' : 'right: 25%;'" :class="{
              'drop-off': feedbackData?.trip.driver?.endLocation?.name,
              end: !feedbackData?.trip.driver?.endLocation?.name,
            }" v-b-tooltip.hover="{
              title: feedbackData?.trip?.endLocation?.name,
              placement:
                isLangRtl && !feedbackData?.trip?.endLocation?.name
                  ? 'lefttop'
                  : 'righttop',
            }">
            </div>

          </div>
          <div class="d-flex justify-content-between mt-3 bg-blue">
            <div :class="[
              'place',
              `${isLangRtl ? 'end' : 'start'}`,
              { 'drop-off': feedbackData?.trip?.startLocation?.name },
            ]">
              {{ $t("pick-up-location") }}
            </div>
            <div :class="[
              'place',
              `${isLangRtl ? 'start' : 'end'}`,
              { 'drop-off': feedbackData?.trip?.endLocation?.name },
            ]">
              {{ $t("drop-off-location") }}
            </div>
          </div>
        </div>
      </section>
      <section v-if="feedbackData.contactPerson">
        <div class="client-general-information__data">
          <ul class="row m-0 p-0">
            <li class="col-12 mb-2">
              <h4>{{ $t("contact-person-information") }}</h4>
            </li>
          </ul>
          <b-table :items="[feedbackData.contactPerson]" :fields="contactPersonFields" show-empty responsive="lg"
            :thead-class="`table-thead text-center bg-transparent`" :tbody-class="`table-tbody text-center`"
            ref="contactPersonTable" class="new-theme-custom-table">
            <template #empty> {{ $t("empty-row") }} </template>
          </b-table>
        </div>
      </section>
       <section v-if="feedbackData.smsToPerson">
        <div class="client-general-information__data">
          <ul class="row m-0 p-0">
            <li class="col-12 mb-2">
              <h4>{{ $t("sms-information") }}</h4>
            </li>
          </ul>
          <b-table :items="[feedbackData.smsToPerson]" :fields="smsToPersonFields" show-empty responsive="lg"
            :thead-class="`table-thead text-center bg-transparent`" :tbody-class="`table-tbody text-center`"
            ref="smsToPersonTable" class="new-theme-custom-table">
            <template #empty> {{ $t("empty-row") }} </template>
          </b-table>
        </div>
      </section>
      <section v-if="feedbackData.feedbackComments">
        <div class="client-general-information__data">
          <ul class="row m-0 p-0">
            <li class="col-12 mb-2">
              <h4>{{ $t("feedback-comments") }}</h4>
            </li>
          </ul>
          <p class="mb-0">{{ feedbackData.feedbackComments }}</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import moment from "moment"

export default {
  name: "FeedbackDetails",
  props: ["feedbackData"],

  computed: {
    contactPersonFields() {
      return [
        { key: 'name', label: this.$t('name'), tdClass: 'text-center' },
        { key: 'mobileNumber', label: this.$t('phone-number'), tdClass: 'text-center' },
        { key: 'email', label: this.$t('email-address'), tdClass: 'text-center' }
      ];
    },
    smsToPersonFields() {
      return [
        { key: 'name', label: this.$t('name'), tdClass: 'text-center' },
        { key: 'mobileNumber', label: this.$t('phone-number'), tdClass: 'text-center' },
        { key: 'type', label: this.$t('type'), tdClass: 'text-center'},
      ];
    }
  },

  methods: {
    formatDate(date) {
      return moment(date).locale("en").format("DD-MM-YYYY HH:mm");
    },
  },
    i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/manageTrips.json"),
      ar: require("@/services/i18n/locales/ar/manageTrips.json"),
    },
  },
};
</script>

<style lang="scss" scoped>
.client-general-information {
  &__description {
    span {
      font-weight: 700;
      font-size: 14px;
      line-height: 35px;
      letter-spacing: 0.44px;
      margin-inline-start: 0.5rem;
    }
  }

  &__action {
    img {
      cursor: pointer;
    }
  }

  &__data {
    background-color: var(--color-01);
    border-radius: 4px;
    padding-inline: 3.3125rem;
    padding-block: 2.3125rem;
    margin-block-start: 0.625rem;
    margin-block-end: 1rem;
    border: 1px solid var(--color-14);
    box-shadow: 0 2px 3px 0 var(--color-38);

    ul {
      li {
        list-style: none;

        h5,
        h4 {
          color: var(--color-02);
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.25px;
          line-height: 20px;
        }

        h4 {
          color: var(--color-03);
          font-size: 15px;
          margin-inline-start: -10px;
        }

        p {
          color: var(--color-17);
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.25px;
          font-weight: 700;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.trip-place-container {
  background-color: var(--color-01);
  border-radius: 4px;
  padding-inline: 3.3125rem;
  padding-block: 2.3125rem;
  margin-block-start: 0.625rem;
  margin-block-end: 2.5625rem;
  border: 1px solid var(--color-14);
  box-shadow: 0 2px 3px 0 var(--color-38);

  ul {
    li {
      list-style: none;

      h4 {
        color: var(--color-03);
        font-size: 15px;
        margin-inline-start: -10px;
      }
    }
  }

  .route {
    height: 0.1875rem;
    background: var(--color-99);
  }

  .point {
    top: -6px;
    border-radius: 50%;
    width: 0.9375rem;
    height: 0.9375rem;
    background-color: var(--color-80);
    border: 4px solid var(--color-89);
  }

  .point.start {
    position: absolute;
    left: 0px;
  }

  .point.end {
    position: absolute;
    right: 0px;
  }

  .point.pick-up {
    position: absolute;
  }

  .point.drop-off {
    position: absolute;
  }

  .place {
    top: 12px;
  }

  .place.start {
    flex: 1;
    text-align: left;
  }

  .place.end {
    flex: 1;
    text-align: right;
  }

  .place.pick-up {
    flex: 1;
    text-align: center;
  }

  .place.drop-off {
    flex: 1;
    text-align: center;
  }
}

@media (max-width: 576px) {
  .client-general-information {
    &__data {
      text-align: center;
      padding-inline: 0.9375rem;
    }
  }
}
</style>